//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles((theme) => ({
  divText: {
    fontSize: 30,
    fontFamily: "segoe-ui!important",
    textAlign: "center",
  },
  mainDiv: {
    position: "absolute",
    left: "50%",
    top: "20%",
    transform: " translate(-50%, -50%)",
  }
}));
